import React from "react";
import { FilterProvider } from "../accounting/FilterProvider.js";
import { AuthProvider } from "../auth/AuthProvider.js";
import { ApplicationRouter } from "./ApplicationRouter.js";
import { ConfigProvider } from "../config/ConfigProvider.js";
import { FrontendConfiguration } from "../../model/config/FrontendConfiguration.js";

type Props = {
  configuration: FrontendConfiguration;
};

/**
 * Main entrypoint to the application. Sets up global state contexts
 * and the application routes.
 */
export const Application = ({ configuration }: Props) => {
  return (
    <ConfigProvider configuration={configuration}>
      <AuthProvider>
        <FilterProvider>
          <ApplicationRouter />
        </FilterProvider>
      </AuthProvider>
    </ConfigProvider>
  );
};
